<template>
  <div
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
  >
    <Tabs type="card" @on-click="tabClick">
      <TabPane
        v-for="(item, i) in packAgeList"
        :key="i"
        :label="item.PackageName"
      >
        <div class="appint_title">{{ item.PackageName }}</div>
        <Table
          :columns="tableColumns"
          :data="tableData"
          border
          style="margin-bottom: 20px"
        ></Table>
        <Page
          :total="PageTotal"
          :current="page"
          :page-size="pageSize"
          @on-change="pageChange"
          style="text-align: right"
        />
        <div class="appint_title">下载物料</div>
        <div class="appint_flex">
          <div class="appint_right" v-show="qrCodeUrl">
            <div class="rel_box">
              <img src="../img/oldqocode.png" alt="" width="220" />
              <img
                class="pos_img"
                :src="'data:image/png;base64,' + qrCodeUrl"
                width="160"
              />
            </div>

            <div class="app_img_center" @click="donloadAppintCode">
              门店专属海报<img src="../img/donload.png" width="20" alt="" />
            </div>
          </div>
          <div v-show="qrCodeUrl">
            <div class="rel_box">
              <img
                src="../img/oldqocode.png"
                alt=""
                width="220"
                style="visibility: hidden"
              />
              <img
                class="pos_img_shop"
                :src="'data:image/png;base64,' + qrCodeUrl"
                alt=""
                width="160"
              />
            </div>
            <div class="app_img_center" @click="donloadShopQrCode">
              门店专属二维码
              <img src="../img/donload.png" width="20" alt="" />
            </div>
          </div>
        </div>
      </TabPane>
    </Tabs>
    <div class="out_box" ref="imageWrapper">
      <img src="../img/oldqocode.png" alt="" width="1044" />
      <img
        class="pos_img_out"
        :src="'data:image/png;base64,' + qrCodeUrl"
        width="700"
      />
    </div>
  </div>
</template>
<script>
import {
  GetShopPackage,
  GetShopPackageDrug,
  GetWxOpenChooseDrugsQRCode_Base64,
} from "@/utils/api.js";
import { getCookie, setCookie, cloneObj, delCookie } from "@/utils/common.js";
import html2canvas from "html2canvas";
export default {
  props: {},
  components: {},
  data() {
    return {
      qrCodeUrl: null,
      appMobilePhone: "",
      PageTotal: 0,
      page: 1,
      tableColumns: [
        {
          title: "通用名",
          key: "ComName",
        },
        {
          title: "商品名",
          key: "Name",
        },
        {
          title: "规格",
          key: "Specs",
        },
        {
          title: "单位",
          key: "Unit",
        },
        {
          title: "厂家",
          key: "FactoryName",
        },
        {
          title: "批准文号",
          key: "ApprovalNumber",
        },
        {
          title: "剂型",
          key: "UpcCode",
        },
        {
          title: "图片",
          key: "Pictures",
          render: (h, params) => {
            let imgArr = [];
            let photo = [];
            let dom = null;
            // params.row.Pictures =
            //   "https://test-pic.lian-ou.com/HMP/Doctor/61016123700e47089e7a4418d6f2cd4f.jpg;https://test-pic.lian-ou.com/HMP/Doctor/18e6b0f402fe479ab25b3f554ec276da.jpg";

            if (params.row.Pictures) {
              params.row.Pictures.split(";").forEach((url) => {
                photo.push(url);
                imgArr.push(
                  h("img", {
                    attrs: {
                      src: url,
                    },
                    style: {
                      with: "40px",
                      height: "40px",
                    },
                  })
                );
              });
            }
            dom = h(
              "viewer",
              {
                props: {
                  images: photo,
                },
              },
              imgArr
            );
            return dom;
          },
        },
      ],
      tableData: [],
      packAgeList: [],
      pageIndex: 1,
      pageSize: 5,
    };
  },
  methods: {
    donloadAppintCode() {
      var cliewidth = 1044 || this.$refs.imageWrapper.offsetWidth;
      var clieheight = 1560 || this.$refs.imageWrapper.offsetHeight;
      // var scale = 2
      var kh = [cliewidth, clieheight];
      console.log(kh);
      html2canvas(this.$refs.imageWrapper, {
        useCORS: true,
        dpi: window.devicePixelRatio * 2,
        scale: 3,
        width: cliewidth,
        height: clieheight,
      }).then((res) => {
        // this.$Message.success("下载成功");
        let posterUrl = res.toDataURL("image/png");
        this.download(posterUrl, kh);
        // this.posterUrl = posterUrl;
        // console.log(posterUrl);
      });
    },
    download(imgurl, kh) {
      this.getUrlBase64(imgurl, kh).then((base64) => {
        let link = document.createElement("a");
        link.href = base64;
        this.posterUrl = base64;
        this.showPosterUrl = true;
        link.download = "门店专属海报.png";
        link.click();
      });
    },
    getUrlBase64(url, kh) {
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.crossOrigin = "Anonymous"; //允许跨域
        img.src = url;
        img.onload = function () {
          canvas.height = kh[1];
          canvas.width = kh[0];
          ctx.drawImage(img, 0, 0, kh[0], kh[1]);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    donloadShopQrCode() {
      var alink = document.createElement("a");
      alink.href = "data:image/png;base64," + this.qrCodeUrl;
      console.log(alink.href);
      alink.download = this.curSelect.PackageName || "pic"; //图片名
      alink.click();
    },
    pageChange(i) {
      this.pageIndex = i;
      this.GetShopDrug();
    },
    tabClick(e) {
      this.curSelect = this.packAgeList[e];
      this.pageIndex = 1;
      this.tableData = [];
      this.PageTotal = 0;
      this.qrCodeUrl = null;
      this.GetShopDrug();
      this.GetBase64();
      //   alert(e);
    },
    getShopPac() {
      let data = {
        ShopId: getCookie("ShopId"),
      };
      GetShopPackage(data).then((res) => {
        if (res.code == 1) {
          this.packAgeList = res.data;
          //默认选中第一个
          if (res.data.length > 0) {
            this.curSelect = res.data[0];
            this.GetShopDrug();
            this.GetBase64();
          } else {
            this.$Message.error("当前暂无套餐");
          }
          //请求数据成功
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    GetShopDrug() {
      let data = {
        packageId: this.curSelect.PackageId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        uniqueId: getCookie("uniqueId"),
      };
      GetShopPackageDrug(data).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.PageTotal = res.data.total;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    GetBase64() {
      // || this.curSelect.PackageCode
      let data = {
        packageCode: this.curSelect.PackageCode,
        uniqueId: getCookie("uniqueId"),
      };
      GetWxOpenChooseDrugsQRCode_Base64(data).then((res) => {
        if (res.code == 1) {
          this.qrCodeUrl = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
  },
  mounted() {
    this.appMobilePhone = localStorage.getItem("app_mobile");
    this.getShopPac();
  },
};
</script>
<style lang="scss" scoped>
.appint_title {
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0 10px 0;
}
.appint_flex {
  display: flex;
}
.appint_right {
  margin-right: 10px;
}
.app_img_center {
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
}
.out_box {
  position: absolute;
  top: -500%;
  right: -500%;
}
.rel_box {
  position: relative;
}
.pos_img {
  position: absolute;
  left: 14%;
  top: 17%;
  border-radius: 43%;
}
.pos_img_shop {
  position: absolute;
  left: 10%;
  top: 23%;
}
.pos_img_out {
  position: absolute;
  left: 16%;
  top: 21%;
  border-radius: 30%;
}
</style>